<template>
    <rkm-area title="Integração BNAFAR - Medicamentos OBM">
        <List :data="data" />
    </rkm-area>
</template>

<script>
// Componentes.
import List from './List.vue'

export default {
    components: {List},
    props: {
        data: {type: Object, required: true},
    },
}
</script>
